import { render } from "./Cancel.vue?vue&type=template&id=264a244b&scoped=true"
import script from "./Cancel.vue?vue&type=script&lang=js"
export * from "./Cancel.vue?vue&type=script&lang=js"

import "./Cancel.vue?vue&type=style&index=0&id=264a244b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-264a244b"]])

export default __exports__